<template>
  <div class="nav-box">
    <ul class="nav">
      <li @click="into('/')">首页</li>
      <li v-for="item in navList" :key="item.id" @click="intoIf(item)">
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, defineProps, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
defineProps({
  navList: {
    type: Array,
    default: [],
  },
});

const $router = useRouter();
const $route = useRoute();
const into = (path) => {
  $router.push({ path });
};
const intoIf = (item) => {
  console.log(item);
  if (item.w_url !== "") {
    window.open(item.w_url);
  } else {
    $router.push({
      path: `/more/${item.id}`,
      query: { title: item.name },
    });
  }
  // const news = $router.resolve({
  //   path: `/more/${item.id}`,
  //   query: { title: item.name },
  // });
  // window.open(news.href, "_blank");
};
</script>

<style lang="scss" scoped>
.nav-box {
  width: 100%;
  height: 40px;
  background-color: #e52a23;
  .nav {
    width: 1150px;
    margin: auto;
    height: 100%;
    display: flex;
    li {
      flex: 1;
      text-align: center;
      font-size: 16px;
      color: #fffdff;
      border-left: 1px #ccc solid;
      line-height: 40px;
      font-weight: 600;
    }
    li:hover {
      background-color: #970000;
      cursor: pointer;
    }
    .nav-home {
      border-right: 1px #ccc solid;
    }
  }
}
</style>
